// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Dashboard',
  subtitle: 'Genel bakış ve istatistikler',
  overview: 'Domain yönetimi ve ödeme takibi genel bakış',
  lastUpdate: 'Son güncelleme',
  totalCustomers: 'Toplam Müşteri',
  activeCustomers: 'Aktif Müşteriler',
  registeredCustomers: 'Kayıtlı müşteri sayısı',
  totalDomains: 'Toplam Domain',
  activeDomains: 'Aktif Domainler',
  totalServers: 'Toplam Sunucu',
  activeServers: 'Aktif sunucu sayısı',
  totalCompanies: 'Toplam Şirket',
  totalPayments: 'Toplam Ödeme',
  pendingPayments: 'Bekleyen Ödemeler',
  pendingTransactions: 'Ödeme bekleyen işlemler',
  overduePayments: 'Gecikmiş Ödemeler',
  expiredPayments: 'Vadesi geçen ödemeler',
  totalRevenue: 'Toplam Gelir',
  totalCollection: 'Toplam tahsilat',
  monthlyRevenue: 'Bu Ay Gelirler',
  yearlyRevenue: 'Yıllık Gelir',
  recentPayments: 'Son Ödemeler',
  upcomingPayments: 'Yaklaşan Ödemeler',
  expiringDomains: 'Süresi Dolan Domainler',
  noData: 'Veri bulunmuyor',
  fetchError: 'Dashboard verileri alınamadı',
  noPendingPayments: 'Bu ay için bekleyen ödeme yok',
  noOverduePayments: 'Gecikmiş ödeme yok',
  noRevenueThisMonth: 'Bu ay için gelir yok',
  daysOverdue: 'gün gecikmiş',
  monthly: 'Aylık',
  yearly: 'Yıllık',
  oneTime: 'Tek Seferlik'
};
